import { render, staticRenderFns } from "./ApplicationFlowOfflineUnderReview.vue?vue&type=template&id=6155b63e&scoped=true&"
import script from "./ApplicationFlowOfflineUnderReview.vue?vue&type=script&lang=js&"
export * from "./ApplicationFlowOfflineUnderReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6155b63e",
  null
  
)

export default component.exports